import useFetch from "../../hooks/use-fetch";
import { Station, StationEntry, UserActivity } from '../../models/daily-activity.models'
import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect, useState } from "react";
import { Card } from 'primereact/card';
import Config from "../../config";
import { DateTime, Duration } from "luxon";
import './avg-time-per-frame-profile.css'

import { DateUtils } from "../../utils/date-utils";
import { ReactECharts } from "../../echarts/react-echarts";
import { Dropdown } from "primereact/dropdown";
import { StationsEnum } from "../../models/stations-enum";



interface IDurationStation {
      stationId: number;
      stationName: string;
      profiles: IDurationStationSku[];
}
interface IDurationStationSku {
      profile: string;
      sizes: IDurationProfileSizes[];
}

interface IDurationProfileSizes {
      size: string;
      avgTime: Duration;
      maxAvgTime: Duration;
      minAvgTime: Duration;
      totalFrames: string;
      stdDevRaw: string;
      stdDev: Duration;
      entries: ISkuDuration[]
      echart: any;
}

interface ISkuDuration {
      productId: string,
      product: string,
      duration: Duration
      millis: number
}

const AverageTimePerFrameProfileReport = () => {

      const [startDate, setStartDate] = useState<DateTime | null>(DateTime.now().startOf('month'));
      const [endDate, setEndDate] = useState<DateTime | null>(DateTime.now());

      const [chartData, setChartData] = useState<IDurationStation[] | null>( null );

      const [isLoadingCharts, setIsLoadingCharts] = useState<boolean>(true);

      const [selectedStation, setSelectedStation] = useState<null | {name:string, code: number}>( null);
      const stations = [
          { name: 'Premiere Boring', code: StationsEnum.boring.valueOf() },
          { name: 'Premiere Coloring', code: StationsEnum.coloring.valueOf() },
          { name: 'Premiere Pins & Magnets', code: StationsEnum.pinsAndMagnets.valueOf() },
          { name: 'Premiere Quality Control', code: StationsEnum.qualityControl.valueOf() },
          { name: 'Premiere Boxing Prep', code: StationsEnum.boxingPrep.valueOf()},
          { name: 'Premiere Boxing', code: StationsEnum.boxing.valueOf() },

          { name: 'Alloy Milling', code: StationsEnum.milling.valueOf() },
          { name: 'Alloy Final Prep', code: StationsEnum.finalPrep.valueOf()},
          { name: 'Alloy Boxing', code: StationsEnum.boxingAlloy.valueOf() },

      ];
  
      const url = startDate && endDate && selectedStation && 
                  `${Config.baseUrl}/api/reports/avg-time-per-frame-profile?stationid=${selectedStation.code.toString()}&startdate=${startDate.toFormat('yyyy-MM-dd')
            + 'T00:00:01'}&enddate=${endDate.toFormat('yyyy-MM-dd') + 'T23:59:59'}`;

      const { data, loading, error } = useFetch<IDurationStation[]>(url ?? "", [], {});


      useEffect(() => {

            function getData() {
                  
                  if (!data || (data as any).length === 0) {
                        return
                  }
                  setIsLoadingCharts( true);
                  let stationEntries = [];
                  for (let station of data) {

                        for (let profile of station.profiles) {
                          
                              
                              for ( let size of profile.sizes ) {
                                    let i = 0;
                                    const categoryData = [];
                                    const valueData = [];
                                    for (let d of size.entries) {

                                          categoryData.push(i);
                                          i = i + 1;
                                          valueData.push(d.millis);

                                    }

                                    let chartOptions: any = {
                                          title: {
                                                text: `${profile.profile} - ${size.size}"`,
                                                left: 10
                                          },
                                          toolbox: {
                                                feature: {
                                                      dataZoom: {
                                                            yAxisIndex: false
                                                      },
                                                      saveAsImage: {
                                                            pixelRatio: 2
                                                      }
                                                }
                                          },
                                          tooltip: {
                                                trigger: 'axis',
                                                axisPointer: {
                                                      type: 'shadow'
                                                },
                                                formatter: function (params: any) {
                                                      const toolTipHtml =     `
                                                            
                                                                                    <div>${DateUtils.toHHMMSS_string( (params[0].value))}</div>
                                                                                                      
                                                                              `;
                                                                              
                                                      return toolTipHtml;
                                                }
                                          },
                                          grid: {
                                                bottom: 90
                                          },
                                          dataZoom: [
                                                {
                                                      type: 'inside'
                                                },
                                                {
                                                      type: 'slider'
                                                }
                                          ],
                                          xAxis: {
                                                data: categoryData,
                                                silent: false,
                                                splitLine: {
                                                      show: false
                                                },
                                                splitArea: {
                                                      show: false
                                                }
                                          },
                                          yAxis: {
                                                splitArea: {
                                                      show: false
                                                }
                                          },
                                          series: [
                                                {
                                                      type: 'bar',
                                                      data: valueData,
                                                      // Set `large` for large data amount
                                                      large: true
                                                }
                                          ]
                                    };
                                    
                                    size.echart = chartOptions;
                              }
                         }
                        
                         
                  }
                  setChartData( data)
                  setIsLoadingCharts(false);
            }

            getData()

      }, [data]);

//Can't get DOM width or height. Please check dom.clientWidth and dom.clientHeight. They should not be 0.For example, you may need to call this in the callback of window.onload. Error Component Stack

      return (

            <div className='report leaderboard'>

                  <div className="calendar-selector">
                        { /*
                        <div className='flex flex-row pl-5'>
                              <h2> Currently selects 2024 data only/automatically </h2>
                              <DateRangePicker startDateCallback={(dateString) => {
                                    setStartDate(DateTime.fromISO(dateString));
                              }}

                              endDateCallback={(dateString) => {
                                    setEndDate(DateTime.fromISO(dateString));
                              }} />

                        </div>
                        */}
                        <h2> Currently selects 2024 data </h2>
                  </div>
                  <div className="card flex justify-content-center">
                        <Dropdown value={selectedStation} onChange={(e) =>{ setChartData(null); setSelectedStation(e.value)}} options={stations} optionLabel="name" 
                              placeholder="Select a Station" className="w-full md:w-14rem" />
                  </div>

                  {error && <div style={{color:"white"}}>An error occurred loading the report.</div>}

                  {loading && <div> <ProgressSpinner /> Loading...</div>}

                  {!loading && chartData &&  chartData.length && chartData.length > 0 && chartData.map((station: IDurationStation, index: number) => {
                        return (
                              <>
                              { station.stationId &&


                              <Card key={`${station.stationName}-${index}`} title={station.stationName}>

                                    {station.profiles.map((profile: IDurationStationSku, index2 ) => {

                                          return (

                                                <div  className="echart-entry" key={`${station.stationName}-charts-wrapper-${index2}`}  >

                                                      {profile && profile.profile && profile.sizes && profile.sizes.map( size =>{
                                                                  return (
                                                                        <>
                                                                           {size && size.echart && 
                             
                                                                                    <ReactECharts  key={`${station.stationName}-${index}-${profile.profile}-${index2}-${size.size}`} theme="light" 
                                                                                                      option={size.echart} 
                                                                                                      style={{ height: "300px", width: "100%" }}
                                                                                                      loading={isLoadingCharts}
                                                                                                       />
                                                                         
                                                                           }
                                                                        </>
                                                                  )
                                                            })
                                                      }

                                                </div>
                                          )
                                    })}

                              </Card>
                                                            }
                              </>
                        )
                  })}

            </div>
      )

}
export default AverageTimePerFrameProfileReport;